/**
 * 2022-02-12
 * origin: https://app.zeplin.io/project/614bed834869303d4a4096e4/screen/61dc3caba7a65728a5d0f923
 * icon卖点组件之No.1
 */
import { TextModule, TextIconCell } from '@/componentsH5/ProductDetailComponents';
import { EFSelect, EFCustomSer } from '@/components/UI/svg//ProductStatic';
import css from './index.module.scss';

const defaultStyle = {
    backColor: 'transparent',
    height: 'auto',
    guideStyle: {
        color: '#03060b',
        fontSize: '0.16rem',
        lineHeight: '0.2rem',
        margin: '0',
        padding: '0',
        fontFamily: 'var(--font-family-SemiBold)',
    },
    titleStyle: {
        color: '#03060b',
        fontSize: '0.24rem',
        ineHeight: '0.34rem',
        margin: '0.06rem 0 0',
        padding: '0',
        fontFamily: 'var(--font-family-Bold)',
    },
    descStyle: {
        color: 'rgb(34,34,34)',
        margin: '0.08rem 0 0 0',
        lineHeight: '.22rem',
        fontSize: '.14rem',
        padding: '0',
        fontFamily: 'var(--font-family-Medium)',
    },
    textIconStyle: {},
};

const defaultData = {
    guide: { text: 'Interior / Exterior Design' },
    title: { type: 'ls', text: 'Power pretty much anything' },
    desc: {
        type: 'sl',
        text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
    },
    items: [
        {
            icon: <EFSelect />,
            title: 'Interior Design',
            des: "DELTA Pro's capacity starts at 3.6kWh. Enough for hours of heavy-duty use.",
            directUrl: '/',
        },
        {
            icon: <EFCustomSer />,
            title: 'Exterior Design',
            des: 'The exterior is built as one piece with tough ABS plastic. As an added measure of safety, it’s fire resistant too.',
            directUrl: '/',
        },
    ],
};
/**
 *
 * @param data {
 *  guide: 参考TextModule组件data参数,
 *  title: 参考TextModule组件data参数,
 *  desc: 参考TextModule组件data参数,
 *  items: 参考TextIconCell组件data参数,
 * }
 * @param defaultStyle{
 *  backColor: 组件整体风格背景色 string,
 *  guideStyle: 参考TextModule组件cssStyle参数,
 *  titleStyle: 参考TextModule组件cssStyle参数,
 *  descStyle: 参考TextModule组件cssStyle参数,
 *  textIconStyle: 参考TextIconCell组件cssStyle参数,
 * }
 */

export default function First({ cssStyle = defaultStyle, data = defaultData }: any) {
    const { guide, title, desc, items } = {
        guide: { ...defaultData.guide, ...data.guide },
        title: { ...defaultData.title, ...data.title },
        desc: { ...defaultData.desc, ...data.desc },
        items: data.items,
    };
    cssStyle.guideStyle = {
        ...defaultStyle.guideStyle,
        ...{
            backColor: cssStyle.backColor,
            color: cssStyle.backColor === ('#000' || '#000000' || 'black') ? '#fff' : '',
        },
        ...cssStyle.guideStyle,
    };
    cssStyle.titleStyle = {
        ...defaultStyle.titleStyle,
        ...{
            backColor: cssStyle.backColor,
            color: cssStyle.backColor === ('#000' || '#000000' || 'black') ? '#fff' : '',
        },
        ...cssStyle.titleStyle,
    };
    cssStyle.descStyle = {
        ...defaultStyle.descStyle,
        ...{
            backColor: cssStyle.backColor,
            color: cssStyle.backColor === ('#000' || '#000000' || 'black') ? 'rgb(145,145,145)' : '',
        },
        ...cssStyle.descStyle,
    };
    cssStyle.textIconStyle = {
        ...defaultStyle.textIconStyle,
        ...{
            wrapperBackColor: cssStyle.backColor,
            titleColor: cssStyle.backColor === ('#000' || '#000000' || 'black') ? '#fff' : '',
            desColor: cssStyle.backColor === ('#000' || '#000000' || 'black') ? 'rgb(145,145,145)' : '#222',
            iconColor: cssStyle.backColor === ('#000' || '#000000' || 'black') ? '#fff' : '',
        },
        ...cssStyle.textIconStyle,
    };
    const { backColor, height, guideStyle, titleStyle, descStyle, textIconStyle } = cssStyle;

    return (
        <div className={`${css.sellPointsModule} sellPointsModuleFirst`} style={{ background: backColor, height: height }}>
            <div className="container">
                <TextModule cssStyle={guideStyle} data={guide} />
                <TextModule cssStyle={titleStyle} data={title} />
                <TextModule cssStyle={descStyle} data={desc} />
                <ul className="sellLists">
                    {items.map((item: any, k: number) => (
                        <li className="list" key={k}>
                            <TextIconCell cssStyle={textIconStyle} data={item} />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
